// Bilingual dictionary for Cauratech landing (ES / EN)
export const translations = {
  es: {
    meta: {
      cta_primary: 'Agenda una reunión',
      cta_secondary: 'Explorar capacidades',
    },
    nav: {
      services: 'Servicios',
      credentials: 'Credenciales',
      about: 'Nosotros',
      tech: 'Tecnología',
      blog: 'Blog',
      contact: 'Contacto',
    },
    hero: {
      kicker: '// CAURATECH · CONFIDENTIAL TECH PARTNER',
      title_a: 'AVANZA',
      title_b: 'AL FUTURO',
      signature: 'Tu identidad secreta tecnológica.',
      subtitle: 'Diseñamos plataformas a medida, gubernamentales y financieras con inteligencia artificial, seguridad de grado gubernamental y blockchain. Clientes de alto perfil. Confidencialidad total.',
      rotatingWords: ['Plataformas', 'Gobierno', 'IA', 'Seguridad', 'Banca', 'Blockchain', 'Automatización'],
      trust: 'Desde 2016 · Aliados de Banca Nacional · Clientes gubernamentales y enterprise · NDA-ready',
      chips: ['Plataformas', 'IA', 'Gov-Grade Security', 'Blockchain', 'Banca'],
    },
    products: {
      kicker: '// Nuestros servicios',
      title: 'Seis pilares para construir el futuro de tu organización',
      subtitle: 'Un equipo multidisciplinario que unifica 8+ años de experiencia en blockchain con capacidades de grado enterprise y gubernamental.',
      items: [
        {
          id: 'platforms',
          name: 'Plataformas a Medida',
          short: 'Software empresarial y gubernamental hecho a tu medida.',
          bullets: [
            'Soluciones enterprise y gubernamentales',
            'Integración con sistemas legacy',
            'Arquitecturas escalables cloud-native',
          ],
        },
        {
          id: 'ai',
          name: 'IA & Automatización',
          short: 'Inteligencia artificial aplicada a procesos críticos.',
          bullets: [
            'Automatización de workflows complejos',
            'Modelos personalizados por industria',
            'Sistemas de decisión aumentada',
          ],
        },
        {
          id: 'security',
          name: 'Seguridad Gov-Grade',
          short: 'Estándares gubernamentales aplicados a tu stack.',
          bullets: [
            'Arquitectura Zero-Trust',
            'Cumplimiento ISO 27001 y NIST',
            'Auditorías y hardening continuo',
          ],
        },
        {
          id: 'blockchain',
          name: 'Blockchain & Web3',
          short: 'Nuestro ADN desde 2016, aplicado a cualquier industria.',
          bullets: [
            'Smart contracts auditables',
            'Tokenización e identidad descentralizada',
            'DeFi, NFTs e infraestructura on-chain',
          ],
        },
        {
          id: 'banking',
          name: 'Soluciones Bancarias',
          short: 'Aliados de la banca nacional en Venezuela.',
          bullets: [
            'Integraciones con core-banking',
            'KYC/AML y compliance',
            'Diversas pasarelas de pago',
          ],
        },
        {
          id: 'cauracademy',
          name: 'Cauracademy',
          short: 'Formación ejecutiva y técnica a medida.',
          bullets: [
            'Programas para C-level y equipos técnicos',
            'Upskilling en blockchain, IA y seguridad',
            'Metodología aplicada con casos reales',
          ],
        },
      ],
      learn_more: 'Saber más',
    },
    credentials: {
      kicker: '// Credenciales',
      title: 'Identidad secreta, credibilidad pública',
      subtitle: 'Trabajamos con instituciones que no pueden fallar — bajo total confidencialidad.',
      quote: '«Somos tu identidad secreta tecnológica»',
      quote_footer: 'Operamos detrás de escena para que tu marca brille al frente.',
      cards: [
        { name: 'Aliados de Banca Nacional', desc: 'Partner tecnológico oficial del sector bancario en Venezuela.' },
        { name: 'Clientes Gubernamentales', desc: 'Plataformas críticas para instituciones públicas de alto impacto.' },
        { name: 'Confidencialidad Total', desc: 'NDA-ready. Protocolos de secreto empresarial en cada proyecto.' },
        { name: 'Seguridad Gov-Grade', desc: 'Arquitecturas Zero-Trust, ISO 27001 y auditorías continuas.' },
      ],
      industries_kicker: 'Sectores que servimos',
      industries: ['Gobierno', 'Banca', 'Enterprise', 'Salud', 'Retail', 'Startups'],
    },
    about: {
      kicker: '// Sobre Cauratech',
      title: 'De pioneros blockchain a partner tecnológico confidencial',
      p1: 'Nacimos en 2016 como pioneros de la cripto economía en mercados emergentes. Durante los últimos años evolucionamos para construir plataformas personalizadas, gubernamentales y financieras para clientes de alto perfil.',
      p2: 'Aliados oficiales de la Banca Nacional en Venezuela, unificamos nuestra experiencia en blockchain con inteligencia artificial y seguridad de grado gubernamental para aplicarla a cualquier rubro, mercado o sistema.',
      p3: 'No estamos en los titulares. Estamos detrás de los sistemas que hacen que otras organizaciones destaquen. Esa es nuestra promesa.',
      badge: '¡Bienvenido al Futuro!',
      values_title: 'Nuestros valores',
      values: [
        { name: 'Integridad', desc: 'Principios éticos, buen juicio y lealtad con cada cliente.' },
        { name: 'Seguridad', desc: 'Estándares gov-grade para proteger información y activos críticos.' },
        { name: 'Transparencia', desc: 'Información clara con tu equipo, discreción con el mundo.' },
        { name: 'Confianza', desc: 'Aliados estratégicos. Coherencia, rigor y responsabilidad.' },
      ],
    },
    tech: {
      kicker: '// Stack tecnológico',
      title: 'Tecnologías que dominamos',
      subtitle: 'Un stack moderno, seguro y escalable — de plataformas cloud-native a infraestructura on-chain.',
      badges: ['AI / ML', 'Automatización', 'Cloud Native', 'Zero-Trust', 'ISO 27001', 'NIST', 'API-first', 'Kubernetes', 'Blockchain', 'Smart Contracts', 'Web3', 'Tokenización'],
      diagram: {
        title: 'De tu problema a tu plataforma',
        nodes: ['Discovery', 'Arquitectura', 'Seguridad Gov-Grade', 'Plataforma en vivo'],
      },
    },
    stats: {
      kicker: '// Impacto',
      title: 'Números que hablan por nosotros',
      items: [
        { label: 'Años construyendo confianza', value: 8, suffix: '+' },
        { label: 'Proyectos entregados', value: 120, suffix: '+' },
        { label: 'Países atendidos', value: 10, suffix: '+' },
        { label: 'Confidencialidad', value: 100, suffix: '%' },
      ],
    },
    blog: {
      kicker: '// Insights',
      title: 'Conocimiento al borde de la frontera',
      subtitle: 'Ideas, casos y guías para avanzar al futuro.',
      read_more: 'Leer más',
    },
    contact: {
      kicker: '// Contacto',
      title: 'Hablemos del futuro que quieres construir',
      subtitle: 'Cuéntanos tu proyecto. Respondemos en menos de 24 horas — siempre bajo confidencialidad.',
      labels: { name: 'Nombre', email: 'Email', company: 'Empresa (opcional)', message: 'Mensaje' },
      placeholders: { name: 'María Pérez', email: 'tu@email.com', company: 'Tu empresa', message: 'Cuéntanos en qué podemos ayudarte...' },
      submit: 'Enviar mensaje',
      success: '¡Mensaje enviado! Te contactaremos pronto.',
      error: 'No pudimos enviar tu mensaje. Intenta de nuevo.',
      newsletter_title: 'Newsletter',
      newsletter_subtitle: 'Recibe insights sobre plataformas, IA, seguridad y blockchain.',
      newsletter_placeholder: 'tu@email.com',
      newsletter_cta: 'Suscribirme',
      newsletter_success: '¡Suscripción confirmada!',
      newsletter_already: 'Ya estabas suscrito. ¡Gracias!',
      newsletter_error: 'No pudimos completar la suscripción.',
    },
    footer: {
      description: 'Cauratech es tu identidad secreta tecnológica. Desde 2016 construimos plataformas críticas para clientes de alto perfil.',
      rights: 'Todos los derechos reservados.',
      columns: {
        product: 'Servicios',
        company: 'Empresa',
        resources: 'Recursos',
      },
    },
    chatbot: {
      launcher: 'Habla con Cauramigo',
      title: 'Cauramigo',
      subtitle: 'Asistente IA · En línea',
      placeholder: 'Pregunta sobre plataformas, IA, seguridad, blockchain...',
      send: 'Enviar',
      greeting: '¡Hola! Soy Cauramigo, el asistente IA de CAURATECH. Construimos plataformas, automatizamos con IA, implementamos seguridad gov-grade y aplicamos blockchain a cualquier industria — siempre bajo total confidencialidad. ¿En qué puedo ayudarte?',
      quick: [
        '¿Qué servicios ofrecen?',
        '¿Cómo funciona la confidencialidad?',
        '¿Qué es seguridad gov-grade?',
        'Háblame de IA aplicada',
      ],
      error: 'Hubo un problema al procesar tu mensaje. Inténtalo nuevamente.',
    },
  },
  en: {
    meta: {
      cta_primary: 'Book a meeting',
      cta_secondary: 'Explore capabilities',
    },
    nav: {
      services: 'Services',
      credentials: 'Credentials',
      about: 'About',
      tech: 'Technology',
      blog: 'Blog',
      contact: 'Contact',
    },
    hero: {
      kicker: '// CAURATECH · CONFIDENTIAL TECH PARTNER',
      title_a: 'ADVANCE',
      title_b: 'TO THE FUTURE',
      signature: 'Your secret tech identity.',
      subtitle: 'We build custom, government and financial-grade platforms with AI, government-grade security and blockchain. High-profile clients. Total confidentiality.',
      rotatingWords: ['Platforms', 'Government', 'AI', 'Security', 'Banking', 'Blockchain', 'Automation'],
      trust: 'Since 2016 · National Banking Allies · Government & enterprise clients · NDA-ready',
      chips: ['Platforms', 'AI', 'Gov-Grade Security', 'Blockchain', 'Banking'],
    },
    products: {
      kicker: '// Our services',
      title: 'Six pillars to build the future of your organization',
      subtitle: 'A multidisciplinary team that unifies 8+ years of blockchain experience with enterprise and government-grade capabilities.',
      items: [
        {
          id: 'platforms',
          name: 'Custom Platforms',
          short: 'Enterprise and government software, tailor-made for you.',
          bullets: [
            'Enterprise and government solutions',
            'Integration with legacy systems',
            'Cloud-native scalable architectures',
          ],
        },
        {
          id: 'ai',
          name: 'AI & Automation',
          short: 'Applied artificial intelligence for critical processes.',
          bullets: [
            'Automation of complex workflows',
            'Industry-specific custom models',
            'Augmented decision systems',
          ],
        },
        {
          id: 'security',
          name: 'Gov-Grade Security',
          short: 'Government standards applied to your stack.',
          bullets: [
            'Zero-Trust architecture',
            'ISO 27001 and NIST compliance',
            'Continuous audits and hardening',
          ],
        },
        {
          id: 'blockchain',
          name: 'Blockchain & Web3',
          short: 'Our DNA since 2016, applied to any industry.',
          bullets: [
            'Auditable smart contracts',
            'Tokenization and decentralized identity',
            'DeFi, NFTs and on-chain infrastructure',
          ],
        },
        {
          id: 'banking',
          name: 'Banking Solutions',
          short: 'Official allies of the national banking sector in Venezuela.',
          bullets: [
            'Core-banking integrations',
            'KYC/AML and compliance',
            'Multiple payment gateways',
          ],
        },
        {
          id: 'cauracademy',
          name: 'Cauracademy',
          short: 'Tailor-made executive and technical training.',
          bullets: [
            'Programs for C-level and technical teams',
            'Upskilling in blockchain, AI and security',
            'Applied methodology with real cases',
          ],
        },
      ],
      learn_more: 'Learn more',
    },
    credentials: {
      kicker: '// Credentials',
      title: 'Secret identity, public credibility',
      subtitle: 'We work with institutions that cannot fail — under full confidentiality.',
      quote: '“We are your secret tech identity”',
      quote_footer: 'We operate behind the scenes so your brand can shine up front.',
      cards: [
        { name: 'National Banking Allies', desc: 'Official tech partner of the banking sector in Venezuela.' },
        { name: 'Government Clients', desc: 'Critical platforms for high-impact public institutions.' },
        { name: 'Total Confidentiality', desc: 'NDA-ready. Trade-secret protocols on every project.' },
        { name: 'Gov-Grade Security', desc: 'Zero-Trust architectures, ISO 27001 and continuous audits.' },
      ],
      industries_kicker: 'Industries we serve',
      industries: ['Government', 'Banking', 'Enterprise', 'Health', 'Retail', 'Startups'],
    },
    about: {
      kicker: '// About Cauratech',
      title: 'From blockchain pioneers to confidential tech partner',
      p1: 'We were born in 2016 as pioneers of the crypto economy in emerging markets. Over the last years we have evolved into a builder of custom, government and financial-grade platforms for high-profile clients.',
      p2: 'Official allies of the National Banking sector in Venezuela, we unify our blockchain experience with artificial intelligence and government-grade security to apply it to any industry, market or system.',
      p3: 'We are not in the headlines. We are behind the systems that make other organizations stand out. That is our promise.',
      badge: 'Welcome to the Future!',
      values_title: 'Our values',
      values: [
        { name: 'Integrity', desc: 'Ethical principles, good judgment and loyalty to every client.' },
        { name: 'Security', desc: 'Gov-grade standards to protect critical information and assets.' },
        { name: 'Transparency', desc: 'Clear information with your team, discretion with the world.' },
        { name: 'Trust', desc: 'Strategic allies. Coherence, rigor and responsibility.' },
      ],
    },
    tech: {
      kicker: '// Tech Stack',
      title: 'Technologies we master',
      subtitle: 'A modern, secure and scalable stack — from cloud-native platforms to on-chain infrastructure.',
      badges: ['AI / ML', 'Automation', 'Cloud Native', 'Zero-Trust', 'ISO 27001', 'NIST', 'API-first', 'Kubernetes', 'Blockchain', 'Smart Contracts', 'Web3', 'Tokenization'],
      diagram: {
        title: 'From your problem to your platform',
        nodes: ['Discovery', 'Architecture', 'Gov-Grade Security', 'Live Platform'],
      },
    },
    stats: {
      kicker: '// Impact',
      title: 'Numbers that speak for themselves',
      items: [
        { label: 'Years building trust', value: 8, suffix: '+' },
        { label: 'Projects delivered', value: 120, suffix: '+' },
        { label: 'Countries served', value: 10, suffix: '+' },
        { label: 'Confidentiality', value: 100, suffix: '%' },
      ],
    },
    blog: {
      kicker: '// Insights',
      title: 'Knowledge on the edge',
      subtitle: 'Ideas, cases and guides to advance to the future.',
      read_more: 'Read more',
    },
    contact: {
      kicker: '// Contact',
      title: "Let's talk about the future you want to build",
      subtitle: 'Tell us about your project. We reply in under 24 hours — always under confidentiality.',
      labels: { name: 'Name', email: 'Email', company: 'Company (optional)', message: 'Message' },
      placeholders: { name: 'Jane Doe', email: 'you@email.com', company: 'Your company', message: 'Tell us how we can help...' },
      submit: 'Send message',
      success: 'Message sent! We will contact you soon.',
      error: 'We could not send your message. Please try again.',
      newsletter_title: 'Newsletter',
      newsletter_subtitle: 'Get insights on platforms, AI, security and blockchain.',
      newsletter_placeholder: 'you@email.com',
      newsletter_cta: 'Subscribe',
      newsletter_success: 'Subscription confirmed!',
      newsletter_already: 'You were already subscribed. Thanks!',
      newsletter_error: 'We could not complete the subscription.',
    },
    footer: {
      description: 'Cauratech is your secret tech identity. Since 2016 we build critical platforms for high-profile clients.',
      rights: 'All rights reserved.',
      columns: {
        product: 'Services',
        company: 'Company',
        resources: 'Resources',
      },
    },
    chatbot: {
      launcher: 'Talk to Cauramigo',
      title: 'Cauramigo',
      subtitle: 'AI assistant · Online',
      placeholder: 'Ask about platforms, AI, security, blockchain...',
      send: 'Send',
      greeting: "Hi! I'm Cauramigo, the AI assistant of CAURATECH. We build platforms, automate with AI, implement gov-grade security and apply blockchain to any industry — always under total confidentiality. How can I help you?",
      quick: [
        'What services do you offer?',
        'How does confidentiality work?',
        'What is gov-grade security?',
        'Tell me about applied AI',
      ],
      error: 'There was a problem processing your message. Please try again.',
    },
  },
};

export const LOGOS = {
  // Square "iso" mark (icon style) — for footer, chatbot, small placements
  isologo_dark_bg: 'https://customer-assets.emergentagent.com/job_442831f5-4cc0-4938-adbe-36470e63af22/artifacts/18f3zr9q_isologo%20cauratech%20fondo%20oscuro.png',
  // Full horizontal wordmark — for navbar hero seals
  logo_horizontal_dark: 'https://customer-assets.emergentagent.com/job_442831f5-4cc0-4938-adbe-36470e63af22/artifacts/6w6li3uw_logo%20cauratech%20fondo%20oscuro.png',
  // Light-bg variants (unused at the moment)
  isologo_light_bg: 'https://customer-assets.emergentagent.com/job_442831f5-4cc0-4938-adbe-36470e63af22/artifacts/yjfobxrp_isologo%20cauratech%20fondo%20claro.png',
  logo_horizontal_light: 'https://customer-assets.emergentagent.com/job_442831f5-4cc0-4938-adbe-36470e63af22/artifacts/m5tua7zw_logo%20cauratech%20fondo%20claro.png',
};
